// Care Management > Overview sub-pages. The sub-page is a path segment
// named after its label (/caremanagement/overview/outreach-operations), not a
// hash; the key is what CareManagement_Overview uses internally.
export const OVERVIEW_SECTIONS = {
  operations: 'daily-operations',
  ct_operations: 'care-transitions-operations',
  outreach_operations: 'outreach-operations',
  complex_care_operations: 'complex-care-operations',
  discharge_waterfall: 'discharge-waterfall',
  pipeline: 'pipeline',
  episode_grouper: 'episode-grouper',
  delivery_report: 'messaging-delivery-report',
};

const SLUG_TO_KEY = Object.fromEntries(Object.entries(OVERVIEW_SECTIONS).map(([key, slug]) => [slug, key]));

export const overviewSectionKey = (slug) => SLUG_TO_KEY[slug] || null;

export const overviewLocation = (key) => ({
  name: 'CareManagement-Operations',
  params: { section: OVERVIEW_SECTIONS[key] || OVERVIEW_SECTIONS.operations },
});

export function overviewRoutes(component, props) {
  return [
    // The tab itself lands on its default sub-page, as Hermes does.
    { path: '/caremanagement/overview', redirect: overviewLocation('operations') },
    {
      // The route name is kept from the old /caremanagement/operations route:
      // usage reporting (kaironlibrary customer-usage-report skill) groups by it.
      path: `/caremanagement/overview/:section(${Object.values(OVERVIEW_SECTIONS).join('|')})`,
      name: 'CareManagement-Operations',
      component,
      props,
      meta: { requiresAuth: true, layout: 'default' },
    },
  ];
}
